import EmptyState from '@components/v2/ui/EmptyState/EmptyState';
import { Stack } from '@mui/material';
import LangEnum from '../../../../../../../lang/LangEnum';
import { OrderConditionsTestIds } from '../../../../../../../utils/testIds/OrderConditions.testIds';

const CONTENT_INDENT = 10;

interface OrderConditionsErrorStateProps {
  onRetry: () => void;
}

const OrderConditionsErrorState = ({ onRetry }: OrderConditionsErrorStateProps) => (
  <Stack
    sx={{
      justifyContent: 'center',
      alignItems: { xs: 'center', md: 'flex-start' },
      ml: { xs: 0, md: CONTENT_INDENT },
      px: { xs: 3, md: 0 },
    }}
  >
    <EmptyState
      testId={OrderConditionsTestIds.TAB_ERROR_STATE}
      title={{ text: LangEnum.ORDER_CONDITIONS_ERROR_TITLE }}
      action={{ primary: { label: LangEnum.GLOBAL_RETRY, onClick: onRetry } }}
    />
  </Stack>
);

export default OrderConditionsErrorState;
